'use strict';
//Constants
var ApplicationConstants = require('../../constants/ApplicationConstants.js');
var YourDetailsConstants = require('../../constants/YourDetailsConstants.js');
var YesNoValues = ApplicationConstants.YesNoValues;
var YesNoRadioData = ApplicationConstants.YesNoRadioData;
//Action
var YourDetailsActions = require('../../actions/YourDetailsActions');
//React/Components
var React = require('react');
var RadioInput = require('../Common/RadioInput.jsx');
var Country = require('../YourDetails/Country.jsx');

var Residence = React.createClass({
    propTypes: {
        index: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.number]),
        section: React.PropTypes.string,
        type: React.PropTypes.oneOf([YourDetailsConstants.ResidenceType.TAX_RESIDENCE, YourDetailsConstants.ResidenceType.COUNTRY_RESIDENCE, YourDetailsConstants.ResidenceType.CITIZENSHIP]).isRequired,
        showQuestion: React.PropTypes.bool,
        data: React.PropTypes.object.isRequired,
        countryLabel: React.PropTypes.string,
        errorList: React.PropTypes.array
    },
    getDefaultProps: function () {
        return {
            index: '',
            section: '',
            showQuestion: true,
            errorList: []
        };
    },
    updateYourDetailsData: function (event) {
        YourDetailsActions.updateYourDetailsData(event.target.model, event.target.id, event.target.value, this.props.index);
    },
    getLabelAndIds: function () {
        switch (this.props.type){
            case YourDetailsConstants.ResidenceType.TAX_RESIDENCE:
                return {
                    question: {
                        label: 'Besides Australia, are you a tax resident of any other country?',
                        id: 'isOtherCountryTaxResident'
                    },
                    country: [{
                        id: 'otherCountryTaxResidence1',
                        placeholder: 'Select country',
                        isShown: (this.props.data.isOtherCountryTaxResident === YesNoValues.YES)
                    }]
                };
            case YourDetailsConstants.ResidenceType.COUNTRY_RESIDENCE:
                return {
                    question: {
                        label: 'Are you a permanent resident of Australia?',
                        id: 'isAustralianResident'
                    },
                    country: [{
                        id: 'countryOfResidence',
                        placeholder: 'Select country',
                        isShown: (this.props.data.isAustralianResident === YesNoValues.NO)
                    }]
                };
            case YourDetailsConstants.ResidenceType.CITIZENSHIP:
                return {
                    question: {
                        label: 'Are you a citizen of a country or countries other than Australia?',
                        id: 'isCitizenOfOtherCountry'
                    },
                    country: [
                        {
                            label: 'Citizenship 1',
                            id: 'citizenship1',
                            placeholder: 'Select',
                            isShown: (this.props.data.isCitizenOfOtherCountry === YesNoValues.YES)
                        },
                        {
                            label: 'Citizenship 2',
                            id: 'citizenship2',
                            placeholder: 'Select',
                            isShown: (this.props.data.isCitizenOfOtherCountry === YesNoValues.YES)
                        }]
                };
            default:
                break;
        }
    },
    render: function () {
        var labelAndIds = this.getLabelAndIds();
        
        var countryComponent = function (data, index) {
            if (data.isShown || !this.props.showQuestion){
                return (
                    <Country key={index}
                            label={data.label || this.props.countryLabel}
                           id={this.props.section + data.id + this.props.index}
                           ref={data.id}
                           value={this.props.data[data.id]}
                           onBlur={this.updateYourDetailsData}
                           model={labelAndIds.country[index].id}
                           errorList={this.props.errorList}
                           disabled={this.props.data[data.id + 'Readonly']}
                           mandatory={data.id !== 'citizenship2'} />
                );
            }
            else{
                return null;
            }
        };
        return (
            <div>
                {this.props.showQuestion ? <RadioInput id={this.props.section + labelAndIds.question.id + this.props.index}
                                                       data={YesNoRadioData}
                                                       value={this.props.data[labelAndIds.question.id]}
                                                       label={labelAndIds.question.label}
                                                       onChange={this.updateYourDetailsData}
                                                       model={labelAndIds.question.id}
                                                       errorList={this.props.errorList}
                                                       disabled={this.props.data[labelAndIds.question.id + 'Readonly']} />
                                          : null}
                {labelAndIds.country.map(countryComponent, this)}
            </div>
        );
    }
});

module.exports = Residence;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/YourDetails/Residence.jsx